import Headroom from 'headroom.js'

if (document.querySelector('.lemonly .page-header')) {
    var myElement = document.querySelector('.lemonly .page-header');
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(myElement);
    // initialise
    headroom.init();
}